import React from 'react';
import { marked } from 'marked';
import {
    BodyContainer,
    Container,
    Image
} from '../../components/StyledComponents/StyledComponents';
import Navigation from '../../components/Navigation/Navigation.jsx';
import Footer from '../../components/Footer/Footer.jsx';
import ProgressBar from '../../components/ProgressBar/ProgressBar';
import CategoryDisplay from '../Article/CategoryDisplay';
import TagsDisplay from '../Article/TagsDisplay';
import AuthorCard from '../AuthorCard/AuthorCard';
import PostNavigation from './PostNavigation';
import MoreKnowledge from './MoreKnowledge';
import { ArticleAd, ArticleEndAd } from '../AdSense/AdComponents';

class BlogPost extends React.Component {

    state = {
        markdown: ''
    }

    componentDidMount() {
        console.log('Intentando cargar:', this.props.content);
        
        fetch(this.props.content)
            .then(response => {
                console.log('Response status:', response.status);
                console.log('Response ok:', response.ok);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.text()
            })
            .then(text => {
                console.log('Texto recibido:', text ? text.substring(0, 100) + '...' : 'texto vacío');
                if (text && typeof text === 'string') {
                    this.setState({
                        markdown: marked.parse(text)
                    })
                } else {
                    console.error('Error: El texto del archivo está vacío o no es válido');
                    this.setState({
                        markdown: '<p>Error al cargar el contenido</p>'
                    })
                }
            })
            .catch(error => {
                console.error('Error al cargar el archivo:', error);
                this.setState({
                    markdown: '<p>Error al cargar el contenido: ' + error.message + '</p>'
                })
            })
    }

    render() {

        const { markdown } = this.state;

        return (
            <Container>
                <ProgressBar />
                <Navigation alwaysVisible={true} />
                <BodyContainer>
                    <Container small top={12}>
                        <h1>{this.props.title}</h1>
                        <p>{this.props.date}</p>
                        
                        {/* Categoría y Tags */}
                        <CategoryDisplay category={this.props.category} />
                        <TagsDisplay tags={this.props.tags} />
                        
                        <Image src={this.props.image} />
                        
                        {/* Anuncio después de la imagen */}
                        <ArticleAd />
                        
                        <div id={`post_${this.props.id}`} dangerouslySetInnerHTML={{__html: markdown}}></div>
                        
                        {/* Anuncio al final del artículo */}
                        <ArticleEndAd />
                        
                        {/* Ficha del autor */}
                        <AuthorCard />
                        
                        {/* Navegación entre entradas */}
                        <PostNavigation currentRoute={this.props.route} />
                    </Container>
                    
                    {/* Sección "Más conocimiento inútil" */}
                    <MoreKnowledge currentRoute={this.props.route} />
                </BodyContainer>
                <Footer />
		    </Container>
        )
    }
}

export default BlogPost;